module.exports = __webpack_public_path__ + "static/img/1.013f577.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/sp/1.png
// module id = s95E
// module chunks = 0